import { EMapService } from '../../types/map';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EMapBehaviorActionTypes {
  SetDefaultMapService = 'mapBehavior/setDefaultMapService',
}

export type TSetDefaultMapServiceActionPayload = EMapService | null;

export type TSetDefaultMapServiceAction = ITypedReduxAction<
  EMapBehaviorActionTypes.SetDefaultMapService,
  TSetDefaultMapServiceActionPayload
>;

export const setDefaultMapService: (payload: TSetDefaultMapServiceActionPayload) => TSetDefaultMapServiceAction =
  actionGenerator<EMapBehaviorActionTypes.SetDefaultMapService, TSetDefaultMapServiceActionPayload>(
    EMapBehaviorActionTypes.SetDefaultMapService,
  );
